import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { CoordinationCardDetailsLogTab as LogTab } from './log';

import { NewCommentView } from 'portcall/eventlog/newcommentview';
import { EventLogView } from 'portcall/eventlog/view';

export const CoordinationCardDetailsLogTabView = SuperCritical(({ model: m } : { model : LogTab }) =>
    <div className="coordinationcarddetailslog">
        <div className="pc-card">
            <div className="pc-card-header pc-card-title">Log</div>
            {/* For now, we don't have server-side support for emailing C-Card log comments to tagged
                users, so suppress the user-tagging UI. */}
            <NewCommentView model={m.NewComment} topLevel allowTaggingUsers={false} />
        </div>
        <EventLogView model={m.EventLog} allowTaggingUsers={false} />
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/logview.tsx